import { render } from "./btnDownload.vue?vue&type=template&id=4304cdfd&ts=true"
import script from "./btnDownload.vue?vue&type=script&lang=ts"
export * from "./btnDownload.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__